import { render, staticRenderFns } from "./addPolicyInfo.vue?vue&type=template&id=226bdae8&scoped=true"
import script from "./addPolicyInfo.vue?vue&type=script&lang=js"
export * from "./addPolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./addPolicyInfo.vue?vue&type=style&index=0&id=226bdae8&lang=scss"
import style1 from "./addPolicyInfo.vue?vue&type=style&index=1&id=226bdae8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bdae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226bdae8')) {
      api.createRecord('226bdae8', component.options)
    } else {
      api.reload('226bdae8', component.options)
    }
    module.hot.accept("./addPolicyInfo.vue?vue&type=template&id=226bdae8&scoped=true", function () {
      api.rerender('226bdae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/addPolicyInfo.vue"
export default component.exports